import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import api from "@api";
import "./Breadcrumbs.css";
import { useBreadcrumbsCache } from "../context/BreadcrumbsCacheContext";


function Breadcrumbs() {
  const cache = useBreadcrumbsCache();
  const location = useLocation();
  const {
    season_id,
    league_id,
    team_id,
    player_id,
    id,
  } = useParams();

  const resolvedSeasonId = season_id || (location.pathname.includes("/seasons/") && id);
  const resolvedLeagueId = league_id || (location.pathname.includes("/leagues/") && id);

  const [seasonName, setSeasonName] = useState(`Season ${resolvedSeasonId}`);
  const [leagueName, setLeagueName] = useState(`League ${resolvedLeagueId}`);
  const [teamName, setTeamName] = useState(`Team ${team_id}`);
  const [playerName, setPlayerName] = useState(`Player ${player_id}`);

  console.log("Breadcrumbs mounted")

  useEffect(() => {
    if (resolvedSeasonId && !cache[`season-${resolvedSeasonId}`]) {
      api.get(`/api/seasonsv2/${resolvedSeasonId}`).then((res) => {
        const name = res.data.season?.name || `Season ${resolvedSeasonId}`;
        cache[`season-${resolvedSeasonId}`] = name;
        setSeasonName(name);
      });
    } else if (resolvedSeasonId) {
      setSeasonName(cache[`season-${resolvedSeasonId}`]);
    }

    if (resolvedSeasonId && resolvedLeagueId && !cache[`league-${resolvedLeagueId}`]) {
      api.get(`/api/seasonsv2/${resolvedSeasonId}/leagues/${resolvedLeagueId}`).then((res) => {
        const name = res.data.league?.name || `League ${resolvedLeagueId}`;
        cache[`league-${resolvedLeagueId}`] = name;
        setLeagueName(name);
      });
    } else if (resolvedLeagueId) {
      setLeagueName(cache[`league-${resolvedLeagueId}`]);
    }

    if (resolvedSeasonId && resolvedLeagueId && team_id && !cache[`team-${team_id}`]) {
      api.get(`/api/seasonsv2/${resolvedSeasonId}/leagues/${resolvedLeagueId}/teams/${team_id}`).then((res) => {
        const name = res.data.team?.name || `Team ${team_id}`;
        cache[`team-${team_id}`] = name;
        setTeamName(name);
      });
    } else if (team_id) {
      setTeamName(cache[`team-${team_id}`]);
    }

    if (player_id && !cache[`player-${player_id}`]) {
      api.get(`/api/playersv2/${player_id}`).then((res) => {
        const player = res.data.player;
        const name = player?.firstName && player?.lastName
          ? `${player.firstName} ${player.lastName}`
          : `Player ${player_id}`;
        cache[`player-${player_id}`] = name;
        setPlayerName(name);
      });
    } else if (player_id) {
      setPlayerName(cache[`player-${player_id}`]);
    }
  }, [resolvedSeasonId, resolvedLeagueId, team_id, player_id]);

  const crumbs = [
    { label: "Seasons", path: "/dashboard/seasons" },
  ];

  if (resolvedSeasonId) {
    crumbs.push({
      label: seasonName,
      path: `/dashboard/seasons/${resolvedSeasonId}`,
    });
  }

  if (resolvedSeasonId && resolvedLeagueId) {
    crumbs.push({
      label: leagueName,
      path: `/dashboard/seasons/${resolvedSeasonId}/leagues/${resolvedLeagueId}`,
    });
  }

  if (resolvedSeasonId && resolvedLeagueId && team_id) {
    crumbs.push({
      label: teamName,
      path: `/dashboard/seasons/${resolvedSeasonId}/leagues/${resolvedLeagueId}/teams/${team_id}`,
    });
  }

  if (player_id) {
    crumbs.push({
      label: playerName,
      path: `/dashboard/players/${player_id}`,
    });
  }

  return (
    <div className="breadcrumbs">
      {crumbs.map((crumb, index) => (
        <span key={index}>
          {index < crumbs.length - 1 ? (
            <>
              <NavLink to={crumb.path}>{crumb.label}</NavLink>
              {" > "}
            </>
          ) : (
            <strong>{crumb.label}</strong>
          )}
        </span>
      ))}
    </div>
  );
}

export default Breadcrumbs;
